import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import { MomentTypes } from 'customer-data-properties/date/MomentTypes'; // @ts-expect-error Legacy code isn't typed.

import * as SimpleDate from 'UIComponents/core/SimpleDate';
import UIDateInput from 'UIComponents/dates/UIDateInput';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import I18n from 'I18n';
import classNames from 'classnames';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import refObject from 'UIComponents/utils/propTypes/refObject'; // SimpleDate isn't typed so we define our own here

function toTimestamp(momentType, type, simpleDate) {
  if (!simpleDate) {
    return null;
  }

  if (type === 'date') {
    return SimpleDate.toMomentUTC(simpleDate).valueOf();
  } else {
    let result;

    if (momentType === MomentTypes.PORTAL) {
      result = SimpleDate.toMomentPortalTz(simpleDate);
    } else {
      result = SimpleDate.toMoment(simpleDate);
    }

    if (type === 'endOfDay') {
      result = result.endOf('day');
    }

    return result.valueOf();
  }
}

function toMoment(momentType, type, valueProp) {
  let value;

  if (valueProp || valueProp === 0) {
    value = Number(valueProp);

    if (isNaN(value)) {
      return null;
    }
  } else {
    return null;
  }

  if (type === 'date') {
    return I18n.moment.utc(value);
  }

  switch (momentType) {
    case MomentTypes.PORTAL:
      return I18n.moment.portalTz(value);

    case MomentTypes.USER:
      return I18n.moment.userTz(value);

    case MomentTypes.MOMENT:
      return I18n.moment(value);

    default:
      return null;
  }
}

export default class CRMPropertyDateInput extends Component {
  constructor(...args) {
    super(...args);

    this.handleChange = evt => {
      const {
        onChange,
        momentType,
        type
      } = this.props;
      const timestamp = toTimestamp(momentType, type, evt.target.value // 'as unknown as SimpleDate | null' is required because UIDateInput types onChange as `React.ChangeEvent<HTMLInputElement>` but actually broadcasts a `SyntheticEventType<SimpleDate | null>`
      );

      if (typeof onChange === 'function') {
        onChange(SyntheticEvent(timestamp));
      }
    };
  }

  getValue() {
    const {
      momentType,
      type,
      value
    } = this.props;
    const moment = toMoment(momentType, type, value);

    if (moment) {
      return SimpleDate.fromMoment(moment);
    }

    return null;
  }

  render() {
    const {
      className,
      inputRef
    } = this.props;
    return /*#__PURE__*/_jsx(UIDateInput, Object.assign({}, getTransferrableProps(this.props), {
      className: classNames('crm-property-date-input', className),
      inputRef: inputRef,
      onChange: this.handleChange,
      value: this.getValue() // HACK: prevent ESC key presses from propagating up and cancelling changes
      // See https://git.hubteam.com/HubSpot/UIComponents/issues/9877
      ,
      onKeyDown: e => e.stopPropagation(),
      onKeyPress: e => e.stopPropagation(),
      onKeyUp: e => e.stopPropagation()
    }));
  }

}
CRMPropertyDateInput.propTypes = {
  className: PropTypes.string,
  inputRef: refObject,
  momentType: PropTypes.oneOf([MomentTypes.USER, MomentTypes.PORTAL, MomentTypes.MOMENT]),
  onChange: PropTypes.func,
  type: PropTypes.oneOf(['default', 'date', 'endOfDay']),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
CRMPropertyDateInput.defaultProps = {
  momentType: MomentTypes.USER,
  type: 'default'
};